import React from 'react';
import theme from './InfoIconWithTooltip.module.scss';
import { Tooltip, TooltipProps } from '@/components/Tooltip';
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

interface InfoIconWithTooltipProps extends Omit<TooltipProps, 'children'> {
    size?: SizeProp;
}

const InfoIconWithTooltip: React.FC<InfoIconWithTooltipProps> = (props) => {
    const { size = 'lg', ...rest } = props;
    return (
        <Tooltip {...rest}>
            <span className={theme.container}>
                <FontAwesomeIcon size={size} icon={faQuestionCircle} fixedWidth />
            </span>
        </Tooltip>
    );
};

export default InfoIconWithTooltip;
